import { Tooltip } from 'antd';
import React from 'react';

import { WarningOutlined } from '@ant-design/icons';

export const WarningIcon = (props) => (
  <Tooltip {...props}>
    <WarningOutlined style={{ color: '#faad14', ...props?.iconStyle }} />
  </Tooltip>
);
